import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { AddToCart } from '@grandvisionhq/carts-v2';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { isDefined } from '@grandvisionhq/utils';
import { SinglePurchasePriceCaption } from '../../../../../components/CTAs/components/SinglePurchasePriceCaption.js';
import { SubscriptionDailyIntervalPriceCaption } from '../../../../../components/CTAs/components/SubscriptionDailyIntervalPriceCaption.js';

var PricedAddToCartCTA = (_param)=>{
    var { price , isCentAmount , priceInterval  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "price",
        "isCentAmount",
        "priceInterval"
    ]);
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(AddToCart, swcHelpers.extends({
        caption: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
            component: "span",
            variant: "body"
        }, getLabel('products.actions.addToCart')), /*#__PURE__*/ React.createElement(PriceCaption, {
            price: price,
            priceInterval: priceInterval,
            isCentAmount: isCentAmount
        }))
    }, props));
};
const PriceCaption = ({ price , isCentAmount , priceInterval  })=>{
    if (!isDefined(price)) return null;
    if (isDefined(priceInterval)) {
        return /*#__PURE__*/ React.createElement(SubscriptionDailyIntervalPriceCaption, {
            price: price,
            isCentAmount: isCentAmount,
            priceInterval: priceInterval
        });
    }
    return /*#__PURE__*/ React.createElement(SinglePurchasePriceCaption, {
        price: price,
        isCentAmount: isCentAmount
    });
};

export { PricedAddToCartCTA };
//# sourceMappingURL=PricedAddToCartCTA.js.map
